export const copyright =
	`© ${new Date().getFullYear()} American Specialty Health Incorporated (ASH). All rights reserved.`;
